var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { map, reduce, each } from 'lodash';
import BaseModel from './BaseModel';
import CustomerModel from './CustomerModel';
import CartItemModel from './CartItemModel';
import DeliveryDetails from './DeliveryDetails';
var moment = require('moment');
var OrderModel = /** @class */ (function (_super) {
    __extends(OrderModel, _super);
    function OrderModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.serviceType = hydrated.serviceType;
        _this.promiseTime = hydrated.promiseTime;
        _this.locationBase = hydrated.locationBase;
        _this.totals = hydrated.totals;
        _this.cart = hydrated.cart;
        _this.customer = hydrated.customer;
        _this.delivery = hydrated.delivery;
        _this.status = hydrated.status;
        _this.trackerStatus = hydrated.trackerStatus;
        return _this;
    }
    OrderModel.prototype.hydrate = function (data) {
        var hydrated = {};
        var body = data;
        var apiOrder = body.api_order;
        var order = body.order;
        var serviceCharges = apiOrder && apiOrder.serviceCharges;
        serviceCharges = reduce(serviceCharges, function (acc, serviceCharge) {
            // serviceCharge object uses 'amount'
            return acc + (serviceCharge.amount || 0);
        }, 0);
        hydrated.id = order.order_id;
        if (apiOrder.totals) {
            var apiTotals = apiOrder.totals;
            var total = apiTotals.collected || order.total_due;
            hydrated.totals = {
                serviceCharge: serviceCharges,
                subtotal: apiTotals.sub_total,
                gratuity: order.gratuity,
                tax: apiTotals.tax,
                total: total,
            };
        }
        if (!hydrated.totals) {
            hydrated.totals = {
                serviceCharge: serviceCharges,
                subtotal: order.subtotal,
                gratuity: order.gratuity,
                total: order.total_due,
            };
        }
        var promiseTimeInSeconds = (order.promise_date) * 1000;
        hydrated.promiseTime = moment(promiseTimeInSeconds);
        hydrated.locationBase = order.location_base;
        hydrated.status = order.status;
        hydrated.serviceType = order.service_type;
        hydrated.cart = map(apiOrder.lineItems, function (lineItem) {
            var item = new CartItemModel(lineItem);
            return item;
        });
        var trackerStatus = 0;
        each(order.items, function (lineItem) {
            trackerStatus = Math.max(lineItem.status, trackerStatus);
        });
        hydrated.trackerStatus = trackerStatus;
        if (order && order.delivery_details) {
            hydrated.delivery = new DeliveryDetails(order.delivery_details);
        }
        var rawCustomer = body.customer;
        if (!rawCustomer) {
            console.warn('No customer found, guest checkout');
        }
        hydrated.customer = (rawCustomer) ? new CustomerModel(rawCustomer) : null;
        return hydrated;
    };
    OrderModel.prototype.hydrateFromRecentOrder = function (data) {
        var hydrated = {};
        var recentOrder = data;
        hydrated.id = recentOrder.id;
        hydrated.serviceType = recentOrder.serviceType;
        hydrated.promiseTime = recentOrder.pomiseDate;
        hydrated.locationBase = recentOrder.locationBase;
        hydrated.totals = recentOrder.totals;
        hydrated.cart = recentOrder.items;
        hydrated.customer = recentOrder.customer;
        hydrated.status = recentOrder.status;
        hydrated.trackerStatus = recentOrder.status || 0; // not applicable to non active orders.
        return hydrated;
    };
    OrderModel.prototype.isDelivery = function () {
        var delivery = this.delivery;
        if (delivery && delivery.getFormattedAddress()) {
            return true;
        }
        return false;
    };
    OrderModel.prototype.getDeliveryAddress = function () {
        var delivery = this.delivery;
        if (delivery && delivery.address) {
            return delivery.address;
        }
        return null;
    };
    OrderModel.prototype.isValidOrder = function () {
        if (this.id && this.locationBase) {
            return true;
        }
        return false;
    };
    return OrderModel;
}(BaseModel));
export default OrderModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/OrderModel.ts
// module id = mt01
// module chunks = 18